import type { AddFlagProps } from '@databases/flags-types';
import MentionIcon from '@databases/icons/migration/mention';
import React from 'react';

import { type ContentTypesFlagProps } from '@canvas/frame-api-types';

import { BaseMentionBuilder } from './baseMentionBuilder.ts';
import { messages } from './i18n.ts';
import { type MentionBuilder } from './types.ts';
import { getDisplayNameForUsers } from './utils/getDisplayNameForUsers.ts';

export class MentionFlagForTwoUsers extends BaseMentionBuilder implements MentionBuilder {
  shouldShowFlag(): boolean {
    return this.usersWithAccess.length === 2;
  }
  build(): AddFlagProps & ContentTypesFlagProps {
    const { displayName, somebodyElse } = getDisplayNameForUsers({
      users: this.usersWithAccess
    });
    const id = `mention-flag-for-two-users-${this.contentId}`;
    const actions = [this.buildFieldSettingsAction(id)];

    return {
      id,
      type: 'custom',
      iconString: 'mention',
      title: this.formatMessage(
        messages['mention-notification.flag-mention-notification-title-two-users'],
        {
          displayName,
          somebodyElse
        }
      ),
      description: !this.isLocked
        ? this.mentionNotificationDescription
        : this.formatMessage(
            messages[
              'mention-notification.flag-mention-notification-description-without-field-settings'
            ]
          ),
      icon: () => <MentionIcon label="" />,
      actions: !this.isLocked ? actions : undefined
    };
  }
}
